import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54dd5aac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "launch-your-product" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "launch-your-product__inner" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = { class: "launch-your-product__title" }
const _hoisted_6 = { class: "lead" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Work with us ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.page?.overSubtitle), 1),
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.page?.title), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.page?.lead), 1),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: "/contact-us",
            class: "btn btn--primary"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}